export const DECREMENT = 'DECREMENT';
export const ASSIGN = 'ASSIGN';
export const MDS_ASSIGN = 'MDS_ASSIGN';
export const CLUSTER_ASSIGN = 'CLUSTER_ASSIGN';
export const FULL_TWEETS_ASSIGN = 'FULL_TWEETS_ASSIGN';
